<input
    #searchInput
    type="text"
    (keydown.escape)="searchInput.blur()"
    maxlength="75"
    (focus)="onFocus()"
    [formControl]="term"
    autocomplete="off"
    class="form-control wk-search__input"
    placeholder="{{ 'SearchBar.PlaceHolder' | translate }}"
/>
<wk-search-result
    [hidden]="!inputFocused || !term.value || term.value.length < minimumCharactersForSearch"
    [cards]="cards"
    [showLoader]="showLoader"
/>
